import { Component, OnInit, ViewChild } from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormArray,
  Validators,
  Form,
} from '@angular/forms';
// import { FileItem, FileLikeObject, FileUploader } from 'ng2-file-upload';
import {
  faCloudUploadAlt,
} from '@fortawesome/free-solid-svg-icons';

// import Swal from 'sweetalert2/dist/sweetalert2.js';
// import { AppSettings } from 'src/app/appSettings';
import { ProductService } from 'src/app/services/product.service';
import { ImportFileComponent } from '../../components/import-file/import-file.component';

@Component({
  selector: 'app-data-import',
  templateUrl: './data-import.component.html',
  styleUrls: ['./data-import.component.scss'],
  host: { class: 'wrapper-settings' },
})
export class DataImportComponent implements OnInit {
  @ViewChild(ImportFileComponent) importFileCmp: ImportFileComponent;

  public loading: boolean = false;
  public changed: boolean = false;

  public settingsFrm: FormGroup;

  public files!: any[];

  public faCloudUploadAlt = faCloudUploadAlt;

  constructor(private _productService: ProductService) {
    this.files = [];
  }

  ngOnInit(): void {
    this.createForm();

    this.getFilesImporting();
  }

  getFilesImporting(): void {
    this.loading = true;
    this._productService.getImportProducts([]).subscribe((res) => {
      if (res['success']) {
        this.files = res['files'];
      }
      this.loading = false;
    });
  }

  createForm() {
    this.settingsFrm = new FormGroup({});
  }

  onChangeImport(bool) {
    this.changed = bool
  }

  onSuccessImport(file) {
    this.files.unshift(file);
  }


  onSubmit() {
    this.importFileCmp.onSubmit()
  }
}
